/**
 * The debug component enables component-to-DOM serialization.
 *
 * @see https://aframe.io/docs/1.3.0/components/debug.html
 */
export var Debug = function Debug(value) {
  var _this = this;

  this.toString = function () {
    return String(_this.value);
  };

  this.value = value;
};